var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchasesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "12px",
    viewBox: "0 0 18 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2022-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Header-/-Main",
    transform: "translate(-335.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(333.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15 L18,15 L18,7 L9,7 L9,15 Z M4,13.829 C5.164,13.416 6,12.304 6,11 C6,9.696 5.164,8.584 4,8.171 L4,7 L7,7 L7,15 L4,15 L4,13.829 Z M18,5 L4,5 C2.897,5 2,5.897 2,7 L2,10 L3,10 C3.551,10 4,10.449 4,11 C4,11.551 3.551,12 3,12 L2,12 L2,15 C2,16.103 2.897,17 4,17 L18,17 C19.103,17 20,16.103 20,15 L20,7 C20,5.897 19.103,5 18,5 Z",
    id: "Shape",
    fillOpacity: 0.75,
    fill: "#FFFFFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasesIcon);
export default __webpack_public_path__ + "static/media/purchasesIcon.2c7efcdfcc0c181d347ae99b5bf1b1ff.svg";
export { ForwardRef as ReactComponent };